var render, staticRenderFns
import script from "./ApplyPrototype.vue?vue&type=script&lang=js&"
export * from "./ApplyPrototype.vue?vue&type=script&lang=js&"
import style0 from "./ApplyPrototype.vue?vue&type=style&index=0&id=4d5cc35c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports